import { TypeInterface } from "./TypeInterface";

import { MainTenant } from "./Types/MainTenant";
import { Occupant } from "./Types/Occupant";
import { Other } from "./Types/Other";

class TypeContainer {

  private types = [
    MainTenant,
    Occupant,
    Other
  ];

  private instances = [
    new MainTenant(),
    new Occupant(),
    new Other()
  ];

  public getTypes() {
    return this.types;
  }

  public getInstances() {
    return this.instances;
  }

  public getSelectableTypes(): TypeInterface[] {
    return this.getInstances().filter((type: TypeInterface) => type.isSelectable() === true);
  }

  public pickFromId(contactForContractTypeId: number): TypeInterface {
    const index = this.getInstances().findIndex(type => type.getValue() === contactForContractTypeId);
    return this.getInstances()[index];
  }

}

export default new TypeContainer();
